import src from "IMAGE";
export default { src, width: 107, height: 32, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AGYODkROCws1NQEBLSsAACUMAAAsAAAAJAAAACkAAAAhAGgTE0pREBA7PgEBMzoAADAOAAAyAAAALgAAADAAAAAz2Z0F7IBtzMQAAAAASUVORK5CYII="};
